import React from "react"
import { AuthProviderContextDispatcher } from "../obj/login/AuthProvider"

function useAuthActions() {
  return React.useContext(AuthProviderContextDispatcher)
}

export default useAuthActions
